import { Box, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    ArrowForwardIos as ArrowForwardIosIcon,
    ArrowBackIos as ArrowBackIosIcon
} from '@mui/icons-material';

const ButtonActions = ({
    disabled = false,
    handleClose,
    renderBackAction,
    confirmText,
    returnText,
    enableForwardIcons,
    enableBackIcons,
    position,
    loading,
    flexDirection,
    onClick,
    id,
    variant,
    startIcon,
    borderRadius,
    confirmColor = 'primary',
    cancelColor = 'primary',
    gap = 1
}: any) => {
    const navigate = useNavigate();
    const { t } = useTranslation('userForm');
    return (
        <Box
            sx={{
                display: 'flex',
                margin: '0 auto',
                whiteSpace: 'nowrap',
                justifyContent: position || 'center',
                alignItems: 'center',
                gap: gap,
                flexDirection: flexDirection || 'inherit',
                '& button': {
                    borderRadius: borderRadius || '8px',
                    width: 'auto'
                },
                textAlign: 'center'
            }}
        >
            {renderBackAction && (
                <Button
                    name="button_actions_cancel"
                    data-testid={'button-action-cancel'}
                    color={cancelColor}
                    startIcon={enableBackIcons ? <ArrowBackIosIcon /> : false}
                    variant={variant ? variant : 'outlined'}
                    onClick={() => {
                        if (handleClose) handleClose();
                        else navigate(-1);
                    }}
                >
                    {returnText || t('goBack')}
                </Button>
            )}
            <Button
                id={id || undefined}
                data-testid={'button-action-submit'}
                name="button_actions_confirm"
                endIcon={enableForwardIcons ? <ArrowForwardIosIcon /> : false}
                startIcon={startIcon ?? false}
                color={confirmColor}
                type={onClick ? 'button' : 'submit'}
                disabled={disabled}
                variant={variant ? variant : 'contained'}
                onClick={onClick || null}
            >
                {confirmText || t('accept')}
                {loading && (
                    <CircularProgress style={{ margin: '0 10px' }} color="inherit" size="1.5em" />
                )}
            </Button>
        </Box>
    );
};

export default ButtonActions;
